<template>
  <div class="Melamine">
    <div class="title">Trichloroethylene</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Items" label="Items"> </el-table-column>
        <el-table-column prop="Units" label="Units" width="100"> </el-table-column>
        <el-table-column prop="Specifications" label="Specifications">
        </el-table-column>
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>In 280kg drums, 22.4mt/20'FCL</p>
    </div>
    <div class="item-huanhang">
      <label>Uses:</label>
      <p>
        Trichloroethylene is an effective solvent for a variety of orgaanic
        materials. It has also been used as a dry cleaning solvent. TCE is also
        used in the manufacture of arange of fluorocarbon refrigerants such as
        1,1,1,2-tetrafluoroethane
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        { Items: "Appearance",Units: "", Specifications: "Transparent Liquid Without Suspened Solids and Sediments"},
        { Items: "Purity",Units: "%", Specifications: ">=99.60"},
        { Items: "Color(Hazen PT-Co color index)",Units: "", Specifications: "<=15"},
        { Items: "Density(p20°C),",Units: "g.cm3", Specifications: "1.460-1.464"},
        { Items: "Distillation Test(0°C, 101.325Kpa)-Initial distilling Temp",Units: "°C", Specifications: ">=85.5"},
        { Items: "Distillation Test(0°C, 101.325Kpa)-Completely distilled Temp",Units: "°C", Specifications: "<=91.0"},
        { Items: "Distillation Test(0°C, 101.325Kpa)-95% distilled Temp",Units: "°C", Specifications: "<=88.5"},
        { Items: "Acidity(HCL)",Units: "%", Specifications: "<=0.001"},
        { Items: "Alkalinity(NaOH)",Units: "%", Specifications: "<=0.025"},
        { Items: "PH",Units: "", Specifications: "8~10"},
        { Items: "Moisture",Units: "%", Specifications: "<=0.01"},
        { Items: "Evaporation Residue",Units: "%", Specifications: "<=0.005"},
        { Items: "Acidity after Oxidation",Units: "%", Specifications: "<=002"},
      
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
